import { Component, computed, inject, signal } from '@angular/core';
import { NavigationHelper } from '../../../helpers/navigationHelper';
import { AuthService } from '../../../services/auth-service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, filter, startWith, map } from 'rxjs';
import { AdminActiveRoutePipe } from "../../../pipes/admin-active-route-pipe";

@Component({
  selector: 'app-header',
  imports: [AdminActiveRoutePipe],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {

  private navigationHelper = inject(NavigationHelper);
  private authService = inject(AuthService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  currentlyLoggedIn = computed(() => this.authService.currentlyLoggedIn());
  canAccessAdmin = computed(() => this.authService.canAccessAdmin());
  currentRoute = signal('');
  isAdmin = computed(() => this.currentRoute() === 'admin');
  menuForMobilShown = signal(false);

  private url$: Observable<string> | undefined;

  ngOnInit() {
    this.url$ = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      startWith(null),
      map(() => {
        const firstChild = this.activatedRoute.firstChild;
        if (firstChild?.snapshot.url.length && firstChild.snapshot.url.length > 0) {
          return firstChild.snapshot.url[0].path;
        }
        return '';
      })
    );

    this.url$.subscribe(url => {
      this.currentRoute.set(url);
    });
  }

  ngOnDestroy() {
    this.url$?.subscribe().unsubscribe();
  }

  navTo(path: string) {
    this.menuForMobilShown.set(false);
    this.navigationHelper.navigateTo([`/${path}`]);
  }

  logOff() {
    this.menuForMobilShown.set(false);
    this.authService.logOff();
    this.navTo('');
  }

  toggleMenu() {
    this.menuForMobilShown.set(!this.menuForMobilShown());
  }
}
